<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Alert, Token } from '@Shelly/shelly-design-system';
	import { _init_weather_components } from '../../../../../../helpers/init_weather_conditions';
	import { is_weather_cond_ui } from '../../../../../../../../types/WeatherConditionUI';
	import { WHEN_WIZARD_STEPS_INDEXES } from '../../helpers/when-wizard-helpers';

	export let sceneData: any;

	const predictionPeriondOptions = [
		{
			value: 1,
			title: $format('label_period_in_hours', { values: { hours: '1' } }),
		},
		{
			value: 2,
			title: $format('label_period_in_hours', { values: { hours: '2' } }),
		},
		{
			value: 3,
			title: $format('label_period_in_hours', { values: { hours: '3' } }),
		},
		{
			value: 4,
			title: $format('label_period_in_hours', { values: { hours: '4' } }),
		},
		{
			value: 5,
			title: $format('label_period_in_hours', { values: { hours: '5' } }),
		},
		{
			value: 6,
			title: $format('label_period_in_hours', { values: { hours: '6' } }),
		},
	];

	let selectedPeriod = {
		value: undefined,
		title: '',
	};

	if (is_weather_cond_ui(sceneData.translated)) {
		sceneData.weatherCondition = { ...sceneData.translated };

		selectedPeriod = {
			...predictionPeriondOptions.find((el) => el.value === sceneData.translated.hours),
		};
	}

	const validateWizardSelectPeriod = () => {
		if (sceneData.validStepIndex > WHEN_WIZARD_STEPS_INDEXES.PREDICTION_PERIOD_STEP) {
			sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.WEATHER_STEP;
			sceneData.isValid = true;
		} else {
			sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.PREDICTION_PERIOD_STEP;
			sceneData.isValid = true;
		}
	};

	const onChangePedictionPeriod = (predictionPeriod) => {
		validateWizardSelectPeriod();
		selectedPeriod = predictionPeriod;
		sceneData.weatherCondition.hours = selectedPeriod.value || 0;
	};
</script>

{#if selectedPeriod.value}
	<Alert
		class="mb-m"
		message={$format('info_msg_prediction_period_forecast', {
			values: { hours: selectedPeriod.value },
			default: `The scene will check the forecast every hour for the next ${selectedPeriod.title} to see if the selected condition is likely to occur`,
		})}
		type="info"
		heading={$format('prediction_condition_title', {
			default: 'Prediction period',
		})}
	/>
{/if}

<Text element="h2" class="mb-s">
	{$format('select_prediction_prop', {
		default: 'Select prediction period',
	})}
</Text>

<div class="d-flex flex-wrap" style="gap:var(--spacing-s)">
	{#each predictionPeriondOptions as predictionPeriod}
		<Token
			id="token-jk4h223"
			title={predictionPeriod.title}
			class="text-capitalize"
			on:click={() => onChangePedictionPeriod(predictionPeriod)}
			selected={selectedPeriod.value === predictionPeriod.value}
		/>
	{/each}
</div>
